// Single source of truth for legal-document versions sent with every consent
// payload to the backend. Each key represents a *distinct* legal artefact —
// they happen to share the same string today (May 2026 release) but will
// drift independently as legal updates one document at a time.
//
// Bumping a value here is a *legal event*, not a deploy event. Coordinate
// with the matching constant in FJCS-backend/app/legal/versions.py — the
// backend Pydantic schemas default to the same value and reject any version
// the user UI did not actually display.
export const LEGAL_VERSIONS = Object.freeze({
  // C2C registration — Terms of Service
  TOS: '2026-05',
  // C2C + B2B candidate-facing — Privacy Policy
  PRIVACY: '2026-05',
  // C2C registration — separate marketing opt-in (Art.7(2), unbundled)
  MARKETING: '2026-05',
  // B2B registration + subscription checkout — Business Terms of Service
  BUSINESS_TERMS: '2026-05',
  // B2B registration — Data Processing Agreement (Art.28)
  DPA: '2026-05',
  // Acceptable Use Policy — acknowledged by each B2B member individually
  // (workspace owner via signup, invitees via invite-accept flow)
  AUP: '2026-05',
  // Cookie banner — ePrivacy / cookie policy
  COOKIE: '2026-05',
  // Candidate-facing AI Disclosure (EU AI Act 2026) on /screen/:token
  AI_PROCESSING: '2026-05',
  // Recruiter attestation when adding a candidate (GDPR Art.6 lawful basis)
  LAWFUL_BASIS: '2026-05',
  // Recruiter attestation when publishing a job (compliance disclosure)
  COMPLIANCE_ATTESTATION: '2026-05',
});
